// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1zA4U","actionsCol":"EnrolledClinics_actionsCol__v6gcf"};